<template>
    <div class="container-fluid mb-5">
        <div class="d-flex justify-content-between align-items-center mt-4">
            <h4>Historia Clínica</h4>
            <a class="smallText text-end" @click.prevent="printHistoria" href="#">🖨️ Imprimir historia clínica</a>
        </div>
        <div v-if="isLoading" class="text-center">
            <p>Cargando historia clínica...</p>
        </div>
        <div v-else>
            <form @submit.prevent="historiaExiste ? actualizarHistoriaClinica() : guardarHistoriaClinica()">
                <div class="card mb-3">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <span>Datos Generales</span>
                        <small v-if="historiaExiste && historiaClinica.ultima_actualizacion" class="text-muted">
                            Última Actualización: {{ formatDateTime(historiaClinica.ultima_actualizacion) }}
                        </small>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                            <p>
                                <strong class="fw-bold">Nombre:</strong> {{ paciente?.nombre || 'No aplica' }} |
                                <strong class="fw-bold">Fecha de Nacimiento:</strong> {{ paciente?.fecha_nacimiento ?
                                formatDate(paciente.fecha_nacimiento) : 'No aplica' }} |
                                <strong class="fw-bold">Género:</strong> {{ paciente?.genero || 'No aplica' }} <br>
                                <strong class="fw-bold">Teléfono:</strong> {{ paciente?.telefono || 'No aplica' }} |
                                <strong class="fw-bold">Email:</strong> {{ paciente?.email || 'No aplica' }} |
                                <strong class="fw-bold">Dirección:</strong> {{ paciente?.direccion || 'No aplica' }} |
                                <strong class="fw-bold">Subsecuencia:</strong> 
                                {{ paciente?.subsecuencia === 'Primera Vez' ? 'Paciente de primera vez' : 'El paciente es subsecuente' }}
                            </p>
                        </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Escolaridad</label>
                                <select class="form-control" v-model="historiaClinica.escolaridad">
                                    <option value="Sin instrucción">Sin instrucción</option>
                                    <option value="Primaria incompleta">Primaria incompleta</option>
                                    <option value="Primaria completa">Primaria completa</option>
                                    <option value="Secundaria incompleta">Secundaria incompleta</option>
                                    <option value="Secundaria completa">Secundaria completa</option>
                                    <option value="Preparatoria o bachillerato incompleto">Preparatoria o bachillerato incompleto</option>
                                    <option value="Preparatoria o bachillerato completo">Preparatoria o bachillerato completo</option>
                                    <option value="Carrera técnica o comercial">Carrera técnica o comercial</option>
                                    <option value="Universidad incompleta">Universidad incompleta</option>
                                    <option value="Licenciatura completa">Licenciatura completa</option>
                                    <option value="Especialidad">Especialidad</option>
                                    <option value="Maestría">Maestría</option>
                                    <option value="Doctorado">Doctorado</option>
                                    <option value="Otra">Otra</option>
                                    <option value="Prefiere no decirlo">Prefiere no decirlo</option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Estado Civil</label>
                                <select class="form-control" v-model="historiaClinica.edo_civil">
                                    <option value="Soltero(a)">Soltero(a)</option>
                                    <option value="Casado(a)">Casado(a)</option>
                                    <option value="Unión libre">Unión libre</option>
                                    <option value="Separado(a)">Separado(a)</option>
                                    <option value="Divorciado(a)">Divorciado(a)</option>
                                    <option value="Viudo(a)">Viudo(a)</option>
                                    <option value="Prefiere no decirlo">Prefiere no decirlo</option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Lateralidad</label>
                                <select class="form-control" v-model="historiaClinica.lateralidad">
                                    <option value="Diestro(a)">Diestro(a)</option>
                                    <option value="Zurdo(a)">Zurdo(a)</option>
                                    <option value="Ambidiestro(a)">Ambidiestro(a)</option>
                                    <option value="No determinado">No determinado</option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Ocupación Anterior</label>
                                <input type="text" class="form-control" v-model="historiaClinica.ocupacion_anterior">
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Ocupación Actual</label>
                                <input type="text" class="form-control" v-model="historiaClinica.ocupacion_actual">
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Religión</label>
                                <select class="form-control" v-model="historiaClinica.religion">
                                    <option value="Ateísmo">Ateísmo</option>
                                    <option value="Agnosticismo">Agnosticismo</option>
                                    <option value="Cristianismo - Católico">Cristianismo - Católico</option>
                                    <option value="Cristianismo - Protestante">Cristianismo - Protestante</option>
                                    <option value="Cristianismo - Evangélico">Cristianismo - Evangélico</option>
                                    <option value="Cristianismo - Ortodoxo">Cristianismo - Ortodoxo</option>
                                    <option value="Cristianismo - Testigos de Jehová">Cristianismo - Testigos de Jehová</option>
                                    <option value="Cristianismo - Mormón (SUD)">Cristianismo - Mormón (SUD)</option>
                                    <option value="Islam - Suní">Islam - Suní</option>
                                    <option value="Islam - Chií">Islam - Chií</option>
                                    <option value="Islam - Otro">Islam - Otro</option>
                                    <option value="Judaísmo - Ortodoxo">Judaísmo - Ortodoxo</option>
                                    <option value="Judaísmo - Reformista">Judaísmo - Reformista</option>
                                    <option value="Judaísmo - Conservador">Judaísmo - Conservador</option>
                                    <option value="Budismo - Mahayana">Budismo - Mahayana</option>
                                    <option value="Budismo - Theravada">Budismo - Theravada</option>
                                    <option value="Budismo - Zen">Budismo - Zen</option>
                                    <option value="Hinduismo">Hinduismo</option>
                                    <option value="Sijismo">Sijismo</option>
                                    <option value="Taoísmo">Taoísmo</option>
                                    <option value="Confucianismo">Confucianismo</option>
                                    <option value="Espiritualidad sin religión">Espiritualidad sin religión</option>
                                    <option value="Religión tradicional indígena">Religión tradicional indígena</option>
                                    <option value="Bahaísmo">Bahaísmo</option>
                                    <option value="Zoroastrismo">Zoroastrismo</option>
                                    <option value="Paganismo / Neopaganismo">Paganismo / Neopaganismo</option>
                                    <option value="Raelismo">Raelismo</option>
                                    <option value="Cienciología">Cienciología</option>
                                    <option value="Otra">Otra</option>
                                    <option value="Prefiere no decirlo">Prefiere no decirlo</option>
                                </select>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Grupo Sanguíneo</label>
                                <select class="form-control" v-model="historiaClinica.grupo_sanguineo">
                                    <option value="A+">A+</option>
                                    <option value="A-">A-</option>
                                    <option value="B+">B+</option>
                                    <option value="B-">B-</option>
                                    <option value="AB+">AB+</option>
                                    <option value="AB-">AB-</option>
                                    <option value="O+">O+</option>
                                    <option value="O-">O-</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        Signos Vitales
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Presión Arterial</label>
                                <input type="text" class="form-control" v-model.trim="historiaClinica.signosVitales.presion_arterial" />
                                <small class="form-text text-muted">Formato "120/80".</small>
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Temperatura (°C)</label>
                                <input type="number" step="0.1" class="form-control" v-model.number="historiaClinica.signosVitales.temperatura" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Frecuencia Cardíaca (lpm)</label>
                                <input type="number" class="form-control" v-model.number="historiaClinica.signosVitales.frecuencia_cardiaca" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Frecuencia Respiratoria (rpm)</label>
                                <input type="number" class="form-control" v-model.number="historiaClinica.signosVitales.frecuencia_respiratoria" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Peso (kg)</label>
                                <input type="number" step="0.1" class="form-control" v-model.number="historiaClinica.signosVitales.peso" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Estatura (m)</label>
                                <input type="number" step="0.01" class="form-control" v-model.number="historiaClinica.signosVitales.estatura" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">IMC</label>
                                <input type="number" step="0.01" class="form-control" v-model.number="historiaClinica.signosVitales.imc" disabled />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Saturación de Oxígeno (%)</label>
                                <input type="number" step="0.1" class="form-control" v-model.number="historiaClinica.signosVitales.saturacion_oxigeno" />
                            </div>
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Glucosa (mg/dL)</label>
                                <input type="number" step="0.1" class="form-control" v-model.number="historiaClinica.signosVitales.glucosa" />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        Antecedentes Heredo-Familiares
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Madre</label>
                                <textarea class="form-control" rows="6" v-model="historiaClinica.familiares_madre" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Padre</label>
                                <textarea class="form-control" rows="6" v-model="historiaClinica.familiares_padre" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Hermanos</label>
                                <textarea class="form-control" rows="6" v-model="historiaClinica.familiares_hermanos" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Abuelos</label>
                                <textarea class="form-control" rows="6" v-model="historiaClinica.familiares_abuelos" maxlength="1000"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        Antecedentes Personales No Patológicos
                    </div>
                    <div class="card-body">
                         <div class="col-md-12 mb-3">
                            <textarea class="form-control" rows="3" v-model="historiaClinica.personales_noPatologicos" maxlength="1000"></textarea>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        Antecedentes Personales Patológicos
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Alergias</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.patologicos_alegrias" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Exposición a Biomasa</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.patologicos_biomasa" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Transfusiones</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.patologicos_transfusiones" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Tabaquismo</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.patologicos_tabaquismo" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Alcoholismo</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.patologicos_alcholismo" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Toxicomanías</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.patologicos_tocicomanias" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Traumatismos</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.patologicos_traumatismos" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Cirugías</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.patologicos_cirugias" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Hospitalizaciones</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.patologicos_hospitalizaciones" maxlength="1000"></textarea>
                            </div>
                             <div class="col-md-12 mb-3">
                                <label class="form-label">Otros</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.patologicos_otros" maxlength="1000"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

                 <div class="card mb-3">
                    <div class="card-header">
                        Padecimientos
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Enfermedades Crónico-Degenerativas</label>
                                <textarea class="form-control" rows="6" v-model="historiaClinica.enfemedades_cronico_degenerativas" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Medicamentos Habituales</label>
                                <textarea class="form-control" rows="6" v-model="historiaClinica.medicamentos_habituales" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label class="form-label">Padecimiento Actual</label>
                                <textarea class="form-control" rows="4" v-model="historiaClinica.padecimiento_ctual" maxlength="1000"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        Interrogatorio por Aparatos y Sistemas
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Síntomas Generales</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.sintomas_generales" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Aparato Respiratorio</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.aparato_respiratorio" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Aparato Cardiovascular</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.aparato_cardiovascular" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Aparato Genitourinario</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.aparato_genitourinario" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Aparato Nervioso</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.aparato_nervioso" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Aparato Endocrinológico</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.aparato_endocrinologico" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Aparato Osteomuscular</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.aparato_osteomuscular" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label class="form-label">Aparato Hematológico</label>
                                <textarea class="form-control" rows="3" v-model="historiaClinica.aparato_hematologico" maxlength="1000"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="card mb-3">
                    <div class="card-header">
                        Exploración Física y Diagnóstico
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <label class="form-label">Exploración Física</label>
                                <textarea class="form-control" rows="4" v-model="historiaClinica.exploracion_fisica" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label class="form-label">Estudios de Laboratorio y Gabinete</label>
                                <textarea class="form-control" rows="4" v-model="historiaClinica.estudios_laboratorio" maxlength="1000"></textarea>
                            </div>
                            <div class="col-md-12 mb-3">
                                    <label class="form-label">Diagnóstico</label>
                                    <multiselect
                                        v-model="selectedDiagnostico"
                                        :options="diagnosticoResults"
                                        label="nombre_busqueda"
                                        track-by="catalog_key"
                                        placeholder="Ingresa el diagnóstico"
                                        @search-change="searchDiagnosticos"
                                        @select="selectDiagnostico"
                                        :loading="isLoadingDiagnostico"
                                        :clear-on-select="true"
                                        :close-on-select="true"
                                        :allow-empty="false"
                                    >
                                    </multiselect>
                                    <small class="text-muted d-block mb-2">{{ historiaClinica.diagnostico || 'No disponible' }}</small>
                                </div>
                        </div>
                    </div>
                </div>

                <div class="text-center mt-4" v-if="userStats !== 1">
                    <vs-button v-if="historiaExiste" type="submit" color="rgb(59,222,200)" gradient block>
                        🔄 Actualizar Historia Clínica
                    </vs-button>
                    <vs-button v-else type="submit" color="rgb(59,222,200)" gradient block>
                        💾 Guardar Historia Clínica
                    </vs-button>
                     <!-- <a class="smallText text-center mt-2 d-block" @click="terminar" href="#">Cancelar</a> -->
                </div>
                <div class="text-center mt-4" v-else>
                    <div class="alert alert-warning text-center">
                    ⚠️ Tu paquete de Medicynia se encuentra expirado. Para continuar utilizando esta funcionalidad, por favor renueva tu suscripción. <br>
                    Aún puedes buscar a tus pacientes y consultar su historial médico, notas médicas y sus derivados. <br>
                    <router-link to="/paquetes">Renovar aquí</router-link>
                </div>
            </div>   
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
var config = require("@/config/api.json");
const API = config.api;
import Multiselect from 'vue-multiselect'; // Import Multiselect

export default {
    name: "HistoriaClinica",
    components: {
            Multiselect, // Register Multiselect
        },
    props: {
        currentUser: {
            type: Object,
            required: true
        },
        paciente: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            historiaClinica: this.inicializarHistoria(),
            historiaExiste: false,
            isLoading: false,
            pacienteIdActual: null,
            diagnosticoResults: [],
            isLoadingDiagnostico:false,
            selectedDiagnostico:null,
            userStats:null
        };
    },
    watch: {
        paciente: {
            handler(newPaciente) {
                console.log("Paciente cambiado:", newPaciente);
                if (newPaciente && (newPaciente.paciente_id || newPaciente.id) !== this.pacienteIdActual) {
                    this.pacienteIdActual = newPaciente.paciente_id || newPaciente.id;
                    console.log("Nuevo paciente ID:", this.pacienteIdActual);
                    this.fetchHistoriaClinica();
                } else if (!newPaciente) {
                    this.resetHistoria();
                }
            },
            immediate: true // Llama al handler inmediatamente después de montar el componente
        },
        // Watcher for IMC calculation
        'historiaClinica.signosVitales.peso': 'calcularIMC',
        'historiaClinica.signosVitales.estatura': 'calcularIMC'
    },
    methods: {
        async printHistoria() {
            // console.log("Imprimiendo historia clínica...", this.paciente, this.historiaClinica);
            const combinedData = {
                paciente: this.paciente,
                historiaClinica: this.historiaClinica,
                displayName: this.currentUser?.displayName || 'No disponible',
            };

            console.log("Datos combinados para imprimir:", combinedData);

                try {
                    this.openLoading();
                    const response = await axios.post(`${API}/imprimir-historiaClinica`, combinedData);

                    if (response.data.status === 'success') {
                        this.closeLoading();
                        await this.callAudit(this.currentUser?.mainId,"IMPRESION","historia_clinica",this.historiaClinica.paciente_id,"Impresión de historia clínica");

                        const pdfUrl = `${API}${response.data.pdfUrl}`;
                        // Verificar si es un dispositivo móvil
                        if (this.isMobileDevice()) {
                            // En móvil, abrir en una nueva pestaña
                            window.open(pdfUrl, '_blank');
                            this.notify('info', 'El PDF se abrirá en una nueva pestaña.');
                        } else {

                            const modal = document.createElement("div");
                            modal.style.position = "fixed";
                            modal.style.top = "0";
                            modal.style.left = "0";
                            modal.style.width = "100%";
                            modal.style.height = "100%";
                            modal.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
                            modal.style.display = "flex";
                            modal.style.justifyContent = "center";
                            modal.style.alignItems = "center";
                            modal.style.zIndex = "1051";

                            const iframe = document.createElement("iframe");
                            iframe.src = pdfUrl;
                            iframe.style.width = "80%";
                            iframe.style.height = "80%";
                            iframe.style.border = "2px solid white";
                            iframe.style.borderRadius = "10px";

                            const closeButton = document.createElement("span");
                            closeButton.textContent = "✖";
                            closeButton.style.position = "absolute";
                            closeButton.style.top = "20px";
                            closeButton.style.right = "20px";
                            closeButton.style.color = "white";
                            closeButton.style.fontSize = "24px";
                            closeButton.style.cursor = "pointer";
                            closeButton.addEventListener("click", () => {
                                document.body.removeChild(modal);
                            });

                            modal.appendChild(iframe);
                            modal.appendChild(closeButton);
                            document.body.appendChild(modal);
                        }
                    } else {
                        this.closeLoading();
                        this.$emit('error', 'Error al generar la nota médica.');
                    }
                } catch (error) {
                    this.closeLoading();
                    console.error(error);
                    this.$emit('error', `Error: ${error.response?.data?.message || error.message}`);
                }
            },
        selectDiagnostico(diagnostico) {
            this.historiaClinica.diagnostico = diagnostico.nombre_busqueda;
        },
        async searchDiagnosticos(query) {
                if (query.trim() === '') {
                    this.diagnosticoResults = [];
                    return;
                }
                this.isLoadingDiagnostico = true;
                try {
                    const response = await axios.post(`${API}/busqueda_cie10`, { searchValue: query });
                    this.diagnosticoResults = response.data;
                } catch (error) {
                    console.error(error);
                    this.notify('error', `Error: ${error.message}`);
                } finally {
                    this.isLoadingDiagnostico = false;
                }
            },
        inicializarHistoria() {
            return {
                userStats:null,
                paciente_id: null,
                escolaridad: 'Sin instrucción', // Valor predeterminado
                edo_civil: 'Soltero(a)', // Valor predeterminado
                lateralidad: 'Diestro(a)', // Valor predeterminado
                ocupacion_anterior: '',
                ocupacion_actual: '',
                religion: 'Prefiere no decirlo', // Valor predeterminado
                grupo_sanguineo: 'A+', // Valor predeterminado
                familiares_madre: '',
                familiares_padre: '',
                familiares_hermanos: '',
                familiares_abuelos: '',
                personales_noPatologicos: '',
                patologicos_alegrias: '',
                patologicos_biomasa: '',
                patologicos_transfusiones: '',
                patologicos_tabaquismo: '',
                patologicos_alcholismo: '',
                patologicos_tocicomanias: '',
                patologicos_traumatismos: '',
                patologicos_cirugias: '',
                patologicos_hospitalizaciones: '',
                patologicos_otros: '',
                enfemedades_cronico_degenerativas: '',
                medicamentos_habituales: '',
                padecimiento_ctual: '',
                sintomas_generales: '',
                aparato_respiratorio: '',
                aparato_cardiovascular: '',
                aparato_genitourinario: '',
                aparato_nervioso: '',
                aparato_endocrinologico: '',
                aparato_osteomuscular: '',
                aparato_hematologico: '',
                exploracion_fisica: '',
                estudios_laboratorio: '',
                diagnostico: '',
                ultima_actualizacion: null, // Añadir campo para la fecha
                // Initialize signosVitales
                signosVitales: {
                    presion_arterial: '0/0',
                    temperatura: 0,
                    frecuencia_cardiaca: 0,
                    frecuencia_respiratoria: 0,
                    peso: 0,
                    estatura: 0,
                    imc: 0,
                    saturacion_oxigeno: 0,
                    glucosa: 0
                }
            };
        },
        resetHistoria() {
            const initialData = this.inicializarHistoria();
            this.historiaClinica = initialData;
            // Ensure signosVitales is also reset
            this.historiaClinica.signosVitales = initialData.signosVitales;
            this.historiaExiste = false;
            this.pacienteIdActual = null;
        },
        async fetchHistoriaClinica() {
            if (!this.paciente || !(this.paciente.paciente_id || this.paciente.id)) {
                this.resetHistoria();
                return;
            }
            this.isLoading = true;
            this.openLoading();
            try {
                const response = await axios.get(`${API}/historia_clinica/${this.paciente.paciente_id || this.paciente.id}`);
                console.log("Historia clínica response:", response.data);
                if (response.data.status === 'success' && response.data.data) {
                    // Asegurarse de que todos los campos existan en el objeto, incluso si son null
                    const fetchedData = response.data.data;
                    const initialData = this.inicializarHistoria();
                    for (const key in initialData) {
                        if (key === 'signosVitales') {
                            // Merge signosVitales specifically, ensuring defaults if not present
                            this.historiaClinica.signosVitales = {
                                ...initialData.signosVitales, // Start with defaults
                                ...(fetchedData.signosVitales || {}) // Overwrite with fetched data if available
                            };
                        } else {
                            this.historiaClinica[key] = fetchedData[key] !== undefined && fetchedData[key] !== null ? fetchedData[key] : initialData[key];
                        }
                    }
                    this.historiaClinica.paciente_id = this.paciente.paciente_id || this.paciente.id; // Asegurar que el paciente_id esté correcto
                    this.historiaExiste = true;
                    this.calcularIMC(); // Calculate IMC after loading data
                    this.notify('info', 'Historia clínica cargada.');
                } else {
                     this.resetHistoria(); // Asegura que el formulario esté limpio si no hay historia
                     this.historiaClinica.paciente_id = this.paciente.paciente_id || this.paciente.id; // Asigna el ID del paciente actual
                     this.notify('info', 'No se encontró historia clínica previa para este paciente. Puede crear una nueva.');
                }
            } catch (error) {
                 if (error.response && error.response.status === 404) {
                    this.resetHistoria(); // Asegura que el formulario esté limpio si no hay historia
                    this.historiaClinica.paciente_id = this.paciente.paciente_id || this.paciente.id; // Asigna el ID del paciente actual
                    this.notify('info', 'No se encontró historia clínica previa para este paciente. Puede crear una nueva.');
                    this.historiaExiste = false;
                } else {
                    console.error("Error fetching historia clinica:", error);
                    this.notify('error', `Error al cargar la historia clínica: ${error.response?.data?.message || error.message}`);
                    this.resetHistoria(); // Resetea en caso de otros errores
                }
            } finally {
                this.isLoading = false;
                this.closeLoading();
            }
        },
        async guardarHistoriaClinica() {
            console.log("Paciente ID:", this.paciente);
            if (!this.paciente || !(this.paciente.paciente_id || this.paciente.id)) {
                this.notify('error', 'No hay un paciente seleccionado.');
                return;
            }
            this.historiaClinica.paciente_id = this.paciente.paciente_id || this.paciente.id; // Asegurar el ID del paciente

            // Validación básica (puedes añadir más si es necesario)
            // if (!this.vEmpty(this.historiaClinica.padecimiento_ctual, 'Padecimiento Actual')) return;
            console.log("Historia clínica a guqqqqqqqqqqqqqqardar:", this.historiaClinica);
          
            this.openLoading();
            try {
                const response = await axios.post(`${API}/historia_clinica`, this.historiaClinica);
                if (response.data.status === 'success') {
                    this.notify('success', 'Historia clínica guardada exitosamente.');

                    await this.callAudit(this.currentUser?.mainId,"CREAR","historia_clinica",this.historiaClinica.paciente_id ,"Se crea historia clínica para el paciente");

                    this.historiaExiste = true; // Marcar que ya existe
                    this.$emit('terminaHistoriaClinica'); // Emitir evento si es necesario
                } else {
                    this.notify('error', `Error al guardar: ${response.data.message}`);
                }
            } catch (error) {
                console.error("Error saving historia clinica:", error);
                this.notify('error', `Error al guardar la historia clínica: ${error.response?.data?.message || error.message}`);
            } finally {
                this.closeLoading();
            }
        },
        async actualizarHistoriaClinica() {
            if (!this.paciente || !(this.paciente.paciente_id || this.paciente.id)) {
                this.notify('error', 'No hay un paciente seleccionado.');
                return;
            }

            // Validación básica
            // if (!this.vEmpty(this.historiaClinica.padecimiento_ctual, 'Padecimiento Actual')) return;

            this.openLoading();
            try {
                // Asegurarse de no enviar el id de la historia clínica si existe en el objeto
                const dataToSend = { ...this.historiaClinica };
                delete dataToSend.id; // El backend usa paciente_id en la URL

                const response = await axios.put(`${API}/historia_clinica/${this.paciente.paciente_id || this.paciente.id}`, dataToSend);
                if (response.data.status === 'success') {
                    this.notify('success', 'Historia clínica actualizada exitosamente.');

                    await this.callAudit(this.currentUser?.mainId,"ACTUALIZAR","historia_clinica",this.paciente.paciente_id || this.paciente.id,"Se actualiza historia clínica para el paciente");

                    // Optionally re-fetch or update the last updated time locally
                    this.historiaClinica.ultima_actualizacion = new Date().toISOString();
                    this.$emit('terminaHistoriaClinica');
                } else {
                    this.notify('error', `Error al actualizar: ${response.data.message}`);
                }
            } catch (error) {
                console.error("Error updating historia clinica:", error);
                this.notify('error', `Error al actualizar la historia clínica: ${error.response?.data?.message || error.message}`);
            } finally {
                this.closeLoading();
            }
        },
        terminar() {
             this.$emit('terminaHistoriaClinica');
        },
        formatDateTime(dateString) {
            if (!dateString) return '';
            try {
                const date = new Date(dateString);
                const dd = String(date.getDate()).padStart(2, '0');
                const mm = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const yyyy = date.getFullYear();
                const hh = String(date.getHours()).padStart(2, '0');
                const min = String(date.getMinutes()).padStart(2, '0');
                return `${dd}-${mm}-${yyyy} ${hh}:${min}`;
            } catch (error) {
                console.error("Error formatting date:", error);
                return 'Fecha inválida';
            }
        },
        calcularIMC() {
            const { peso, estatura } = this.historiaClinica.signosVitales;
            if (peso > 0 && estatura > 0) {
                this.historiaClinica.signosVitales.imc = parseFloat((peso / (estatura ** 2)).toFixed(2));
            } else {
                this.historiaClinica.signosVitales.imc = 0; // Reset to 0 if inputs are invalid
            }
        }
    },
    mounted() {
        setTimeout(() => {
                this.userStats = this.getUserStatus();
            }, 500);
    }
};
</script>

<style scoped>

textarea {
    resize: vertical; /* Permite redimensionar verticalmente */
}
</style>
